<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 20V19.25C18 16.9028 16.0972 15 13.75 15H6.25C3.90279 15 2 16.9028 2 19.25V20" stroke="inheri"
    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <circle cx="10" cy="7" r="4" stroke="inheri" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M19 9V13" stroke="inheri" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M21 11H17" stroke="inheri" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
